import {
  Row,
  Col,
  InputGroup,
  Input,
  Button,
  InputGroupText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import React from "react";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import type { ISortOption } from "../../components/sortDropdown";
import Dashboard from "../../components/dashboard";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import ISortByType from "../../../types/services/ISortByType";
import {
  serviceCaller,
  withModals,
  ServiceCallerProps,
  ModalProps,
  withLoginRedirect,
} from "../../composition";
import { firebaseConnect, isEmpty, isLoaded } from "react-redux-firebase";
import { connect } from "react-redux";
import get from "lodash.get";
import isEqual from "lodash.isequal";
import ISegment from "../../../types/services/ISegment";
import { getParsedDate, moneyFormat } from "../../../utils/helpers";
import { ScaleLoader } from "react-spinners";
import * as commonActions from "../../../utils/actions/common";
import ISelectionUpdate from "../../../types/ISelectionUpdate";
import {
  isCurrentUserAdmin,
  isCurrentUserCollaborator,
  isCurrentUserOnlyCollaborator,
} from "../../../utils/roleCheck";
import firebase from "firebase/compat/app";
import App = firebase.app.App;
import IColumnName from "../../../types/IColumnName";
import {
  applyColumnPrefs,
  TableIds,
  toggleSavedColumn,
} from "../../../utils/tablePrefs";
import { deleteSegment, enqueueReindexOperation } from "../../../utils/fetch";
import { ThankYouAdminBulkAction } from "../thankYouAdmins";
import {
  isOrdinaryDonorList,
  staffDisplayName,
} from "../thankYouAdmins/helpers";

import {
  hideColumnWithoutGiveSpark,
  selectUsesGiveSpark,
} from "../../../utils/giveSpark";
interface Props extends ServiceCallerProps, ModalProps {
  usesGiveSpark: boolean;
  segments: Array<ISegment>;
  firebase: App;
  selectElement: (quantity: string, message: string) => void;
  refreshDashboard: () => void;
  hideSelection: () => void;
}

interface IExtendedSegment extends ISegment {
  createdOnStr: string;
  modifiedOnStr: string;
}

interface State {
  sortBy: ISortByType;
  searchText: string;
  searchTextUsed: string;
  selectAll: boolean;
  sortAsc: boolean;
  showExportModal: boolean;
  isLoaded: boolean;
  segmentList: Array<IExtendedSegment>;
  selectedIds: string[];
  suppressedIds: string[];
  columnNames: Array<IColumnName>;
  actionsMenuOpen: boolean;
  thankYouBulkOpen: boolean;
}

const sortOptions: ISortOption[] = [
  { key: "NAME", show: "Segment", colName: "name" },
  { key: "DONOR_COUNT", show: "# of Contacts", colName: "donorCount" },
  { key: "CREATED", show: "Date Created", colName: "createdOnStr" },
  { key: "UPDATED", show: "Last Update", colName: "modifiedOnStr" },
];

class SegmentsPage extends React.PureComponent<Props, State> {
  state = {
    sortBy: sortOptions[0],
    searchText: "",
    searchTextUsed: "",
    selectAll: false,
    sortAsc: true,
    showExportModal: false,
    isLoaded: false,
    segmentList: null,
    selectedIds: [],
    suppressedIds: [],
    actionsMenuOpen: false,
    thankYouBulkOpen: false,
    columnNames: applyColumnPrefs(TableIds.segments, [
      { key: "Segment", isDisabled: false },
      { key: "# of Contacts", isDisabled: false },
      { key: "Date Created", isDisabled: false },
      { key: "Last Update", isDisabled: false },
      { key: "TY Users", isDisabled: false },
    ]),
  };

  searchTimeout = null;

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.handleWindowSize);
    }
    if (this.searchTimeout && window) {
      window.clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  }

  handleWindowSize = () => {
    if (window) {
      if (window.innerWidth < 768) {
        this.setState({
          columnNames: applyColumnPrefs(TableIds.segments, [
            { key: "Segment", isDisabled: false },
            { key: "# of Contacts", isDisabled: false },
            { key: "Date Created", isDisabled: true },
            { key: "Last Update", isDisabled: true },
            { key: "TY Users", isDisabled: true },
          ]),
        });
      } else {
        this.setState({
          columnNames: applyColumnPrefs(TableIds.segments, [
            { key: "Segment", isDisabled: false },
            { key: "# of Contacts", isDisabled: false },
            { key: "Date Created", isDisabled: false },
            { key: "Last Update", isDisabled: false },
            { key: "TY Users", isDisabled: false },
          ]),
        });
      }
    }
  };

  componentDidMount() {
    this.props.hideSelection();
    if (!isCurrentUserCollaborator(this.props.currentCharity)) {
      this.props.hideSelection();
    }
    if (this.props.segments) {
      this.fillNewList();
    }
    if (window) {
      this.handleWindowSize();
      window.addEventListener("resize", this.handleWindowSize);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.isLoaded &&
      this.props.segments &&
      this.props.segments.length > 0
    ) {
      this.fillNewList();
      return;
    }
    if (
      !isEqual(this.props.segments, prevProps.segments) ||
      this.state.searchTextUsed !== prevState.searchTextUsed
    ) {
      this.fillNewList();
    }
    if (this.props.currentCharity.id !== prevProps.currentCharity.id) {
      this.setState({
        isLoaded: false,
      });
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  fillNewList = () => {
    let newSegmentList: any[] = [];
    if (this.props.segments) {
      if (this.state.searchText) {
        newSegmentList = this.props.segments.filter(segment =>
          segment.name
            .toLowerCase()
            .includes(this.state.searchTextUsed.toLowerCase())
        );
      } else {
        newSegmentList = newSegmentList.concat(this.props.segments);
      }
      newSegmentList = this.sortSegments(this.state.sortBy, newSegmentList);
    }
    newSegmentList = newSegmentList.map(segment => {
      return {
        ...segment,
        name: segment.isKeyword ? "Keyword - " + segment.name : segment.name,
      };
    });
    this.setState(
      {
        segmentList: newSegmentList,
        isLoaded: true,
      },
      () => {
        this.props.refreshDashboard();
      }
    );
  };

  sortSegments(
    newOption: ISortOption,
    newSegmentList: Array<IExtendedSegment>
  ): Array<IExtendedSegment> {
    switch (newOption.colName) {
      case "donorCount":
        newSegmentList.sort((a, b) => {
          return (a.donorCount || 0) - (b.donorCount || 0);
        });
        break;
      case "createdOnStr":
        newSegmentList.sort((a, b) => {
          return a.createdOn - b.createdOn;
        });
        break;
      case "modifiedOnStr":
        newSegmentList.sort((a, b) => {
          return a.modifiedOn - b.modifiedOn;
        });
        break;
      default:
        newSegmentList.sort(function(a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    }
    if (!this.state.sortAsc) {
      newSegmentList.reverse();
    }
    return newSegmentList;
  }

  handleColumnHeaderSort = (accessor: string) => {
    const option = sortOptions.find(o => o.colName === accessor);
    if (!option) {
      return;
    }
    this.setState(
      prev => {
        const same = prev.sortBy.colName === option.colName;
        return {
          sortBy: option,
          sortAsc: same ? !prev.sortAsc : false,
        };
      },
      () => this.fillNewList()
    );
  };

  selectAllCheck = e => {
    this.setState({
      selectAll: e.target.checked,
      selectedIds: [],
      suppressedIds: [],
    });
  };

  clearSearch = () => {
    this.setState({ searchText: "", searchTextUsed: "" }, () => {
      this.props.refreshDashboard();
    });
  };

  searchTextChange = e => {
    const newText: string = e.target.value;

    if (this.searchTimeout && window) {
      window.clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    this.setState({
      searchText: newText,
      selectAll: false,
    });

    let timeout = 200;
    if (newText && newText.length < 3) {
      timeout = 1500;
    }

    if (window) {
      this.searchTimeout = window.setTimeout(() => {
        this.setState({
          searchTextUsed: newText,
          selectAll: false,
        });
      }, timeout);
    }
  };

  showDonors = (segment: ISegment) => {
    if (!isCurrentUserCollaborator(this.props.currentCharity)) {
      this.props.selectElement("0", "Donors Selected");
    }

    const from = segment.isKeyword ? "keyword" : "segment";
    this.props.navigate(`/segments/${segment.id}/contacts/${from}`);
  };

  disableInfo = (segment: ISegment) => {
    return segment.isKeyword;
  };

  editSegment = (segment: ISegment) => {
    if (this.disableInfo(segment)) {
      return;
    }
    this.props.navigate(`${segment.id}`);
  };

  createNewSegment = () => {
    this.props.navigate("new");
  };

  toggleActionsMenu = () => {
    this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
  };

  execSegmentReindex = async () => {
    const searchUrl = this.props.config?.searchServiceUrl;
    const charityId = this.props.currentCharity?.id;
    if (!searchUrl || !charityId) {
      return;
    }
    const confirmed = window.confirm(
      "Queue a full segment reindex for this charity?"
    );
    if (!confirmed) {
      return;
    }
    this.setState({ actionsMenuOpen: false });
    try {
      await enqueueReindexOperation(searchUrl, charityId, "segments");
      window.alert("Segment reindex queued.");
    } catch (err) {
      window.alert(err && err.message ? err.message : "Request failed.");
    }
  };

  selectedSegmentIds = () => {
    if (this.state.selectAll && this.state.segmentList) {
      return this.state.segmentList
        .map(segment => segment.id)
        .filter(id => !this.state.suppressedIds.includes(id));
    }
    return this.state.selectedIds;
  };

  hasOrdinarySelection = () => {
    const selected = this.selectedSegmentIds();
    const list = this.state.segmentList || [];
    return selected.some(id =>
      isOrdinaryDonorList(list.find(segment => segment.id === id))
    );
  };

  openThankYouBulk = () => {
    if (!this.hasOrdinarySelection()) {
      return;
    }
    this.setState({ thankYouBulkOpen: true });
  };

  closeThankYouBulk = () => {
    this.setState({ thankYouBulkOpen: false });
  };

  selectionUpdate = (update: ISelectionUpdate) => {
    this.setState({
      selectedIds: update.selectedIds,
      suppressedIds: update.suppressedIds,
    });
  };

  deleteSegments = async () => {
    if (
      confirm(
        "Are you sure you wish to delete the selected segments?. Segments associated with Keywords won't be deleted"
      )
    ) {
      let toDelete = [];
      if (!this.state.selectAll && this.state.selectedIds) {
        toDelete = this.state.selectedIds;
      } else if (this.state.selectAll) {
        toDelete = this.state.segmentList
          .map(segment => segment.id)
          .filter(id => !this.state.suppressedIds.includes(id));
      }

      toDelete = toDelete.filter(
        s => !this.state.segmentList.find(seg => s === seg.id).isKeyword
      );

      if (toDelete.length > 0) {
        for (const i in toDelete) {
          await deleteSegment(
            this.props.currentCharity.id,
            toDelete[i],
            this.props.config.adminServiceUrl,
            this.props.serviceAccessToken
          );
        }

        //Doing this locally as is faster that going around through firebase
        const cleanSegments = this.state.segmentList.filter(
          s => !toDelete.includes(s.id)
        );
        this.setState(
          {
            segmentList: cleanSegments,
          },
          () => this.props.refreshDashboard()
        );
      }
    }
  };

  disableColumn = index => {
    const copy = toggleSavedColumn(
      TableIds.segments,
      this.state.columnNames,
      index
    );
    this.setState(
      {
        columnNames: copy,
      },
      () => {
        this.props.columnsModalChange(this.state.columnNames);
      }
    );
  };

  changeColumns = () => {
    this.props.toggleColumnsModal(this.disableColumn, this.state.columnNames);
  };

  columnData = [
    "name",
    "donorCount",
    "createdOnStr",
    "modifiedOnStr",
    "thankYouUsers",
  ];

  extraColumns = [
    {
      id: "info",
      hasTooltip: true,
      tooltipText: "Segment Detail",
      type: "icon",
      width: 40,
      faIcon: "fa-edit",
      className: "customColUsersIcon",
      showFunctions: this.editSegment,
      isDeactivated: this.disableInfo,
      deactivatedClassName: "customColUsersIconDeactivated",
    },
    {
      id: "users",
      hasTooltip: true,
      tooltipText: "Contact List",
      type: "icon",
      width: 40,
      faIcon: "fa-user-circle",
      className: "customColUsersIcon",
      showFunctions: this.showDonors,
    },
  ];

  getSegments = (currentPage, pageSize) => {
    let total = pageSize * currentPage;
    return Promise.resolve({
      result: this.state.segmentList.slice(total, total + pageSize),
      totalAmount: this.state.segmentList.length,
      pageAmount: Math.ceil(this.state.segmentList.length / pageSize),
      time: Date.now(),
    });
  };

  renderDashboard() {
    if (
      this.props.serviceAccessToken &&
      this.state.segmentList &&
      (this.state.segmentList.length >= 0 ||
        this.state.searchText.length > 0) &&
      this.state.isLoaded
    ) {
      return (
        <Dashboard
          tableId={TableIds.segments}
          columnNames={hideColumnWithoutGiveSpark(
            this.state.columnNames,
            "TY Users",
            this.props.usesGiveSpark
          )}
          columnData={this.columnData}
          extraColumns={this.extraColumns}
          checkCol={isCurrentUserCollaborator(this.props.currentCharity)}
          selectAllInCheckboxHeader
          onSelectAllCheckboxChange={this.selectAllCheck}
          suppressedIds={this.state.suppressedIds}
          selectionUpdate={this.selectionUpdate}
          hideSelection={!isCurrentUserCollaborator(this.props.currentCharity)}
          sortBy={this.state.sortBy.colName}
          selectAll={this.state.selectAll}
          sortAsc={this.state.sortAsc}
          searchText={this.state.searchTextUsed}
          filtered={!!this.state.searchTextUsed}
          footerMessage="Segments Selected"
          currentCharity={this.props.currentCharity}
          noDataText={"No Segments Found"}
          getResponse={this.getSegments}
          columnHeaderSort={{
            sortAccessor: this.state.sortBy.colName,
            sortAscending: this.state.sortAsc,
            sortableAccessors: sortOptions.map(o => o.colName),
            onSort: this.handleColumnHeaderSort,
          }}
        />
      );
    } else {
      return (
        <div className={s.loader}>
          <ScaleLoader color={"#1f65b1"} loading />
        </div>
      );
    }
  }
  render() {
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row className={s.marginBot}>
            <Col xs={12} className={classNames(s.colMargin, s.noPadding)}>
              <div className={s.segmentsToolbarFlex}>
                <div className={s.toolbarLeft}>
                  <div
                    className={s.inlineDots}
                    onClick={this.changeColumns}
                    onKeyDown={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        this.changeColumns();
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    data-tip
                    data-for="segments-column-mgmt"
                    aria-label="Column management"
                  >
                    <i className={"fa fa-columns " + s.dotIcon}>&nbsp;</i>
                  </div>
                  <ReactTooltip
                    id="segments-column-mgmt"
                    effect="solid"
                    place="top"
                  >
                    Column management
                  </ReactTooltip>
                </div>
                <div className={s.toolbarSearchGrow}>
                  <InputGroup className={s.searchInputFullWidth}>
                    <InputGroupText className={s.inputGroup}>
                      <i className={classNames("fa fa-search", s.searchIcon)}>
                        &nbsp;
                      </i>
                    </InputGroupText>
                    <Input
                      id="searchText"
                      placeholder={"Search"}
                      value={this.state.searchText}
                      onChange={this.searchTextChange}
                      className={s.text}
                    />
                    <InputGroupText className={s.inputGroupRight}>
                      <i
                        className={classNames("fa fa-times", s.closeIcon)}
                        onClick={this.clearSearch}
                      >
                        &nbsp;
                      </i>
                    </InputGroupText>
                  </InputGroup>
                </div>
                {isCurrentUserCollaborator(this.props.currentCharity) && (
                  <div className={s.toolbarActions}>
                    <Button
                      id="NewSegmentButton"
                      color="primary"
                      className={s.newPrimaryButton}
                      onClick={this.createNewSegment}
                    >
                      New Segment
                    </Button>
                    <Dropdown
                      isOpen={this.state.actionsMenuOpen}
                      toggle={this.toggleActionsMenu}
                    >
                      <DropdownToggle
                        color="link"
                        className={s.toolbarExtras}
                        aria-label="More actions"
                      >
                        <i className="fa fa-ellipsis-v" />
                      </DropdownToggle>
                      <DropdownMenu right className={s.actionsDropdownMenu}>
                        <DropdownItem
                          onClick={this.deleteSegments}
                          disabled={
                            !this.state.selectAll &&
                            this.state.selectedIds.length == 0
                          }
                        >
                          Delete Segment
                        </DropdownItem>
                        {isCurrentUserAdmin(this.props.currentCharity) && (
                          <DropdownItem
                            disabled={
                              !this.props.usesGiveSpark ||
                              !this.hasOrdinarySelection()
                            }
                            onClick={this.openThankYouBulk}
                          >
                            Add thank you users
                          </DropdownItem>
                        )}
                        {this.props.isAdminDebugUi && (
                          <DropdownItem onClick={this.execSegmentReindex}>
                            Reindex segments
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </Dropdown>
                    {isCurrentUserAdmin(this.props.currentCharity) && (
                      <ThankYouAdminBulkAction
                        selectedSegmentIds={this.selectedSegmentIds()}
                        isOpen={this.state.thankYouBulkOpen}
                        onClose={this.closeThankYouBulk}
                      />
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row>{this.renderDashboard()}</Row>
        </div>
      </main>
    );
  }
}

const thankYouUserNames = (charityData, segmentId: string): string[] => {
  const rows = get(charityData, `thankYouAdminSegments.${segmentId}`) || {};
  const users = get(charityData, "users") || {};
  return Object.keys(rows).map(userId => {
    const user = users[userId];
    const row = rows[userId] || {};
    return (
      (user && staffDisplayName(user)) || row.name || row.email || userId
    );
  });
};

const mapStateToProps = state => {
  const { firebase, user } = state;
  const charityData = firebase.data[user.currentCharity.id];
  return {
    firebase: firebase,
    usesGiveSpark: selectUsesGiveSpark(state),
    segments:
      isLoaded(firebase.data[user.currentCharity.id]) &&
      isLoaded(firebase.data[user.currentCharity.id].segments)
        ? !isEmpty(firebase.data[user.currentCharity.id].segments)
          ? get(firebase, `ordered.${user.currentCharity.id}.segments`).map(
              segment => {
                let filters = "";
                if (segment.value.recency) {
                  filters +=
                    (segment.value.recency.minValue
                      ? segment.value.recency.minValue / 30
                      : "0") + " - ";
                  filters +=
                    (segment.value.recency.maxValue
                      ? segment.value.recency.maxValue / 30
                      : "60+") + " months, ";
                }
                if (segment.value.frequency) {
                  filters +=
                    (segment.value.frequency.minValue
                      ? segment.value.frequency.minValue
                      : "0") + " - ";
                  filters +=
                    (segment.value.frequency.maxValue
                      ? segment.value.frequency.maxValue
                      : "100") + " gifts, ";
                }
                if (segment.value.amount) {
                  filters +=
                    "$" +
                    (segment.value.amount.minValue
                      ? `${moneyFormat(segment.value.amount.minValue / 100.0)}`
                      : "0.00") +
                    " - ";
                  filters += segment.value.amount.maxValue
                    ? `$ ${moneyFormat(segment.value.amount.maxValue / 100.0)}`
                    : "Any amount";
                }
                if (filters.endsWith(", ")) {
                  filters = filters.substring(0, filters.length - 2);
                  filters += "\n";
                }
                return {
                  ...segment.value,
                  name:
                    segment.value.name +
                    (segment.value.isDonorList ? "" : "\n" + filters),
                  id: segment.key,
                  thankYouUsers: thankYouUserNames(charityData, segment.key),
                  createdOn: segment.value.createdOn
                    ? segment.value.createdOn
                    : 0,
                  modifiedOn: segment.value.modifiedOn
                    ? segment.value.modifiedOn
                    : 0,
                  createdOnStr: segment.value.createdOn
                    ? getParsedDate(
                        new Date(segment.value.createdOn).toString(),
                        false,
                        "MM/DD/YYYY, hh:mm a"
                      )
                    : "Not available",
                  modifiedOnStr: segment.value.modifiedOn
                    ? getParsedDate(
                        new Date(segment.value.modifiedOn).toString(),
                        false,
                        "MM/DD/YYYY, hh:mm a"
                      )
                    : "Not available",
                };
              }
            )
          : []
        : null,
  };
};

const mapDispatchToProps = dispatch => ({
  selectElement: (quantity = null, message = null) => {
    dispatch(commonActions.selectElement(quantity, message));
  },
  refreshDashboard: () => {
    dispatch(commonActions.refreshDashboard());
  },
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withModals(
        firebaseConnect((_, store) => {
          return store.getState().user.currentCharity.id !== ""
            ? [
                {
                  path: `${store.getState().user.currentCharity.id}/segments`,
                },
                {
                  path: `${
                    store.getState().user.currentCharity.id
                  }/thankYouAdminSegments`,
                },
                {
                  path: `${store.getState().user.currentCharity.id}/users`,
                },
              ]
            : [];
        })(withStyles(s)(SegmentsPage))
      )
    )
  )
);
